import React, { useRef, useState, useEffect, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { connect } from "react-redux"
import { Modal } from "antd"
import axios from "axios"
import classNames from "classnames"
import { motion, useMotionValueEvent, useScroll } from "framer-motion"

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { APP_LOCALE, getLanguage, useLanguage } from "@languages/index"
import { LOCALES } from "@constants/locales"
import DOMAIN from "@constants/domain"
import ButtonCommonJapan from "@components/buttonCommonJapan"


const IMG_HEADER = "/assets/images/invite/jp/invite-intro-header.webp"

const IMG_INVITE_INTRO_01 = "/assets/images/invite/jp/invite-intro-01.webp";
const IMG_INVITE_INTRO_02 = "/assets/images/invite/jp/invite-intro-02.webp";
const IMG_INVITE_INTRO_03 = "/assets/images/invite/jp/invite-intro-03.webp";

const IMG_INVITE_INTRO_01_M = "/assets/images/invite/jp/invite-intro-01-m.webp";
const IMG_INVITE_INTRO_02_M = "/assets/images/invite/jp/invite-intro-02-m.webp";
const IMG_INVITE_INTRO_03_M = "/assets/images/invite/jp/invite-intro-03-m.webp";


const InviteIntroJp = (props) => {
  const languageCode = getLanguage()
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.invite }

  const navigate = useNavigate()
  const [showFloatingButtons, setShowFloatingButtons] = useState(false)
  const [isProgressModalVisible, setIsProgressModalVisible] = useState(false)
  const [isCompleteModalVisible, setIsCompleteModalVisible] = useState(false)
  const [isManagerModalVisible, setIsManagerModalVisible] = useState(false)

  const scrollContainerRef = useRef(null)
  const { scrollY } = useScroll({
    container: scrollContainerRef,
  })

  useMotionValueEvent(scrollY, "change", (latest) => {
    const nextState = latest > 500 ? true : false
    if (showFloatingButtons != nextState) {
      setShowFloatingButtons(nextState)
    }
  })

  const openPDF = () => {
    let url = "https://" + DOMAIN.BASE.URL + "/intro/invite.pdf"
    window.open(url, "_blank")
  }

  const footerAnimVariants = {
    hidden: { opacity: 0, y: 300 },
    show: { opacity: 1, y: 0 },
  }

  const storeContact = () => {
    const members = props.brand.members.map((member) => {
      return {
        name: member.name,
        role: member.role,
        mobile: member.mobile,
      }
    })

    let api, message
    switch (APP_LOCALE) {
      case LOCALES.JA:
        api = "https://brand.kyolook.com/business/contact"
        message = `${languageTexts.intro_text_1} (JP)`
        break
      default:
        api = "https://brand.nmodelin.com/business/contact"
        message = `${languageTexts.intro_text_1} (KR)`
        break
    }

    axios
      .post(api, {
        name: props.brand.name,
        contact: JSON.stringify(members, undefined, 2),
        message: message,
      })
      .then((response) => {})
      .catch((error) => {
        console.log(error)
        alert(error.message)
      })
  }

  const showLoadingModal = () => {
    setIsProgressModalVisible(true)
  }

  const CLASS_MAP = {
    sectorContainerBase: "mx-auto px-[16px] md:px-[20px] w-full md:w-[1240px] max-w-[480px] md:max-w-[1240px]",
    sectorContainerVerticalPadding: "py-[40px] md:py-[75px]",
  }

  const BaseView = (props) => {
    return (
      <>
        <div id="header-title" className="w-full md:min-w-[1240px] flex flex-col md:flex-row-reverse">
          <div className="relative aspect-[375/100] md:aspect-auto w-full h-auto md:h-[360px]">
            <img
              className="absolute w-full h-full object-cover"
              src={IMG_HEADER}
              alt="invite-intro-header"
            />
          </div>
          <div className="py-[14px] w-full md:w-[577px] flex justify-center items-center bg-[#FF0099]">
            <p className="text-[24px] md:text-[46px] text-white font-bold text-center">
              <span>
                {`オフライン`}
              </span>
              <br className="hidden md:block"/>
              <span>
                {`招待`}
              </span>
            </p>
          </div>
        </div>


        <div id="header-content" className="bg-white">
          <div className={classNames([
            CLASS_MAP.sectorContainerBase,
            CLASS_MAP.sectorContainerVerticalPadding,
          ])}>
            <p className="whitespace-pre-wrap text-start md:text-center text-[20px] md:text-[38px] font-bold">
              {[
                `インフルエンサーを招待して`,
                `オフラインでの売上を活性化させてください`
              ].join('\n')}
            </p>
            <p className="mt-[13px] md:mt-[16px] text-start md:text-center text-[16px] md:text-[22px]">
              {`インフルエンサーがオフライン店舗に訪問し投稿をします。`}
            </p>

            <div className="mt-[26px] md:mt-[40px] flex flex-col md:flex-row justify-center items-center gap-[22px] md:gap-[65px]">
              <ButtonCommonJapan
                renderContent={() => (
                  <span className="text-[20px] md:text-[22px] font-bold text-white">
                    {`紹介書ダウンロード`}
                  </span>
                )}
                onClick={openPDF}
                containerClass="w-[296px] md:w-[335px] px-[16px] py-[14px] md:py-[16px]"
                iconContainerClass="right-[14px] md:right-[16px]"
                iconClass="w-[24px] md:w-[28px] h-[24px] md:h-[28px]"
              />
              <ButtonCommonJapan
                renderContent={() => (
                  <span className="text-[20px] md:text-[22px] font-bold text-white">
                    {`お問い合わせ`}
                  </span>
                )}
                href="/brand/contact"
                containerClass="w-[296px] md:w-[335px] px-[16px] py-[14px] md:py-[16px]"
                iconContainerClass="right-[14px] md:right-[16px]"
                iconClass="w-[24px] md:w-[28px] h-[24px] md:h-[28px]"
              />
            </div>

            <p className="mt-[41px] md:mt-[93px] whitespace-pre-wrap text-start md:text-center text-[20px] md:text-[38px] font-bold">
              {[
                `オフラインイベントを`,
                `知人たちだけのイベントとして行っていませんか？`
              ].join('\n')}
            </p>
            <p className="mt-[13px] md:mt-[16px] text-start md:text-center text-[16px] md:text-[22px]">
              {`知人たちだけに訪問要請をするのには限界があります。`}
            </p>
          </div>
        </div>


        <div id="sector-1" className="bg-[#F5F5F5]">
          <div className={classNames([
            CLASS_MAP.sectorContainerBase,
            CLASS_MAP.sectorContainerVerticalPadding,
            "flex flex-col md:flex-row gap-[15px] md:gap-[45px]"
          ])}>
            <div className="md:w-1/2 flex flex-col justify-center">
              <p className="text-[20px] md:text-[38px] font-bold">
                <span>
                  {`訪問を望むインフルエンサーを`}
                </span>
                <br />
                <span className="text-[#FF0099]">
                  {`選択するだけで完了します`}
                </span>
              </p>
              <p className="mt-[9px] md:mt-[17px] text-[16px] md:text-[20px]">
                {`応募したインフルエンサーのうち、自社のイベントに合う人を選んでください。`}
              </p>
            </div>
            <div className="w-full md:w-1/2 flex justify-center items-center">
              <img
                alt="invite-intro-01-m"
                className="w-full h-full md:hidden"
                src={IMG_INVITE_INTRO_01_M}
              />
              <img
                alt="invite-intro-01"
                className="w-full h-full hidden md:block"
                src={IMG_INVITE_INTRO_01}
              />
            </div>
          </div>
        </div>


        <div id="sector-2" className="bg-white">
          <div className={classNames([
            CLASS_MAP.sectorContainerBase,
            CLASS_MAP.sectorContainerVerticalPadding,
            "flex flex-col gap-[24px] md:gap-[27px]"
          ])}>
            <div className="flex flex-col justify-center">
              <p className="text-center text-[20px] md:text-[38px] font-bold">
                <span className="text-[#FF0099]">
                  {`たった3分で`}
                </span>
                <br />
                <span>
                  {`インフルエンサーの募集開始`}
                </span>
              </p>
              <p className="text-center mt-[9px] md:mt-[17px] text-[16px] md:text-[20px]">
                {`すぐにイベントの参加人員を集めることができます。`}
              </p>
            </div>

            <div className="mx-auto">
              <img
                alt="invite-intro-02-m"
                className="w-full max-w-[337px] h-full md:hidden"
                src={IMG_INVITE_INTRO_02_M}
              />
              <img
                alt="invite-intro-02"
                className="w-full h-full hidden md:block"
                src={IMG_INVITE_INTRO_02}
              />
            </div>
          </div>
        </div>


        <div id="sector-3" className="bg-[#F5F5F5]">
          <div className={classNames([
            CLASS_MAP.sectorContainerBase,
            CLASS_MAP.sectorContainerVerticalPadding,
            "flex flex-col gap-[32px] md:gap-[36px]"
          ])}>
            <div className="flex flex-col justify-center">
              <p className="text-center text-[20px] md:text-[38px] font-bold">
                <span>
                  {`オフラインに招待することで`}
                </span>
                <br />
                <span className="text-[#FF0099]">
                  {`得られる効果`}
                </span>
              </p>
              <p className="text-center mt-[9px] md:mt-[17px] text-[16px] md:text-[20px] whitespace-pre-wrap">
                {[
                  `10ブランドのインタビュー平均値です。`,
                ].join('\n')}
              </p>
            </div>
            <div className="mx-auto">
              <img
                alt="invite-intro-03-m"
                className="w-full max-w-[224] h-full md:hidden"
                src={IMG_INVITE_INTRO_03_M}
              />
              <img
                alt="invite-intro-03"
                className="w-full h-full hidden md:block"
                src={IMG_INVITE_INTRO_03}
              />
            </div>
          </div>
        </div>
      </>
    );
  }


  return (
    <div
      ref={scrollContainerRef}
      style={{
        maxHeight: "100dvh",
        overflow: "scroll",
      }}
    >
      <BaseView />

      <motion.div
        className="fixed bottom-0 left-0 right-0 md:mb-[40px]"
        variants={footerAnimVariants}
        initial={"hidden"}
        animate={showFloatingButtons ? "show" : "hidden"}
        transition={{ type: "just" }}
      >
        <div className="flex flex-row cursor-pointer mt-[-1px] justify-center items-center border-t border-[#E8E8E8] md:border-0 md:gap-[12px]">
          <div
            className="bg-[#000000] flex flex-1 flex-col justify-center items-center md:rounded-full md:max-w-[248px] break-keep max-h-[60px]"
            style={{
              boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)",
            }}
            onClick={() => {
              openPDF()
            }}
          >
            <span className="text-[12px] md:text-[16px] font-bold text-center text-[#FFF] px-[40px] py-[18px]">
              {languageTexts.intro_text_21}
            </span>
          </div>

          <div
            className="bg-[#FF0099] flex flex-col justify-center items-center md:rounded-full"
            style={{
              boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)",
            }}
            onClick={() => {
              showLoadingModal()
            }}
          >
            <span className="text-[12px] md:text-[16px] font-bold text-center text-[#FFF] px-[40px] py-[18px]">
              {languageTexts.intro_text_22}
            </span>
          </div>
        </div>
      </motion.div>

      <ProgressModal
        isProgressModalVisible={isProgressModalVisible}
        onComplete={() => {
          storeContact()
          setIsProgressModalVisible(false)
          setIsCompleteModalVisible(true)
        }}
      />

      <CompleteModal
        isCompleteModalVisible={isCompleteModalVisible}
        onComplete={() => {
          setIsCompleteModalVisible(false)
          setIsManagerModalVisible(true)
        }}
      />

      <ManagerModal
        name={props.brand.name}
        avatar={
          APP_LOCALE === LOCALES.KO
            ? "/assets/images/manager/manager-mikyeong.png"
            : "/assets/images/manager/manager-momo.png"
        }
        isManagerModalVisible={isManagerModalVisible}
        onOk={() => {
          setIsManagerModalVisible(false)
        }}
      />
    </div>
  )
}

const ProgressModal = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.invite }
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (props.isProgressModalVisible == false) {
      setProgress(0)
    }

    if (props.isProgressModalVisible) {
      const targetProgress = 100
      const duration = 2000

      const startTime = Date.now()

      const increaseProgress = () => {
        const currentTime = Date.now()
        const elapsedTime = currentTime - startTime

        if (progress < targetProgress && elapsedTime < duration) {
          setProgress(Math.min(targetProgress, (elapsedTime / duration) * targetProgress))
          requestAnimationFrame(increaseProgress)
        } else {
          setProgress(100)
          props.onComplete ? props.onComplete() : null
        }
      }

      increaseProgress()
    }
  }, [props.isProgressModalVisible])

  return (
    <Modal centered={true} open={props.isProgressModalVisible} onOk={props.handleOk} footer={null} closable={false}>
      <div className="text-center text-black text-[17px] font-normal py-[15px]">{languageTexts.intro_text_23}</div>

      <div className="text-center text-black text-lg font-bold">{progress.toFixed(1)}%</div>

      <div className="w-[275px] h-[6px] bg-gray-200 rounded-[32px] relative my-[10px] mx-auto">
        <div
          className="absolute inset-0 h-full bg-orange-500 rounded-[32px]"
          style={{
            width: `${progress.toFixed(1)}%`,
          }}
        />
      </div>
    </Modal>
  )
}

const CompleteModal = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.invite }
  useEffect(() => {
    if (props.isCompleteModalVisible) {
      setTimeout(() => {
        props.onComplete ? props.onComplete() : null
      }, 1000)
    }
  }, [props.isCompleteModalVisible])

  return (
    <Modal centered={true} open={props.isCompleteModalVisible} footer={null} closable={false}>
      <div className="flex flex-col gap-[16px]">
        <div className="text-center text-black text-[17px] font-normal py-[15px]">{languageTexts.intro_text_24}</div>

        <div className="mx-auto flex justify-center items-center">
          <img src={`/assets/icons/check-orange.svg`} />
        </div>
      </div>
    </Modal>
  )
}

const ManagerModal = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.invite }
  return (
    <Modal centered={true} open={props.isManagerModalVisible} footer={null} closable={false}>
      <div className="flex flex-col gap-[30px] py-[50px]">
        <div className="flex flex-col justify-center mx-auto items-center gap-[10px]">
          <img src={`${props.avatar}`}></img>
          <div className="text-black text-[17px] font-bold">{languageTexts.intro_text_25}</div>
          {/* <img className="max-w-[58px]" src={`/assets/logo/logo-black-sm.svg`}></img> */}
        </div>
        <div className="text-center text-black text-[17px] font-normal py-[15px]">
          {languageTexts._intro_text_26(props.name)}
        </div>
      </div>

      <div className="w-full flex flex-col pb-[50px]">
        <div
          className="flex justify-center items-center w-[140px] h-12 bg-orange-500 rounded-[41px] mx-auto cursor-pointer"
          onClick={props.onOk ? props.onOk : null}
        >
          <div className="text-center text-white text-[17px] font-bold">{languageTexts.confirm}</div>
        </div>
      </div>
    </Modal>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(InviteIntroJp)
